import { render } from "./ColorPickerModal.vue?vue&type=template&id=60abdc45&scoped=true"
import script from "./ColorPickerModal.vue?vue&type=script&lang=js"
export * from "./ColorPickerModal.vue?vue&type=script&lang=js"

import "./ColorPickerModal.vue?vue&type=style&index=0&id=60abdc45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60abdc45"]])

export default __exports__